<script>
  //settings

  export let flip = false;
  export let disabled = false;
  export let color = "white";
  export let expand = false;

  //enable click handeling

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  function handleClick() {
    if (disabled) return;
    // Sende ein Custom-Event mit dem Namen "buttonClicked"
    dispatch("buttonClicked");
  }
</script>

<div
  class="chevron_wrapper"
  class:expand={expand === true}
  class:flip={flip === true}
  class:orange={color === "orange"}
  class:disabled={disabled === true}
  on:click={handleClick}
  on:keypress={handleClick}
  role="button"
  tabindex="0"
>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.35 7.05011L7.2 12.9001L6.7 13.4001L0 6.70011L6.7 0.000106812L7.2 0.500107L1.35 6.35011H13.4V7.05011H1.35Z"
      fill="currentColor"
    />
  </svg>
</div>

<style lang="scss">
  .flip {
    transform: rotate(180deg);
  }

  .chevron_wrapper {
    cursor: pointer;
    display: flex;
    height: 2rem;
    width: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background-color: #282828;
    color: #fff;
    transition: 300ms ease-in-out;
  }

  .chevron_wrapper:hover {
    background-color: #2a2a2f !important;
    color: white !important;
  }

  .orange {
    background-color: #ff5f1f !important;
    color: white !important;
  }

  .orange:hover {
    background-color: #191919;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 30%;
  }

  .expand {
    height: 3rem;
    width: 3rem;
  }
</style>
